import { useEffect, useState } from 'react';
import { Box, ButtonBase, makeStyles, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import _ from 'lodash';
import moment from 'moment';
import TableUI from '../../../../components/TableUI';
import Text from '../../../../components/Text';
import { Checkbox } from '../../../DutyAssign/components/Attendance/Setting';
import { DeleteIcon, InfoIcon } from '../../../../components/Icon';
import { bedStatusAPI } from '../../../../apis';
import { ORDER_SERVICE_STATUS_ENUM } from '../../../../comm/constant';
import { useEnableServiceOrder } from '../../../../utils/hooks';
import ServiceHistoryPopup from './ServiceHistoryPopup';
import CancelServicePopup from './CancelServicePopup';

export const OrderedCleaningService = ({ marginLeft = '1.25rem', marginTop = '0', tableId, tableName, reminder }) => {
  const classes = useStyles();
  const [orderList, setOrderList] = useState([]);
  const { enableOrderService } = useEnableServiceOrder();

  const getCleansingList = async () => {
    try {
      const params = {
        tableId,
        tableName,
      };
      const { result } = await bedStatusAPI.getCleansingList(params);
      setOrderList(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    enableOrderService && getCleansingList();
  }, [enableOrderService]);

  return (
    orderList?.length > 0 && (
      <Box
        flexBasis="50%"
        display="flex"
        flexDirection="column"
        bgcolor="#F5FAFF"
        borderRadius="0.9375rem"
        p="1.25rem 2rem 0"
        ml={marginLeft}
        mt={marginTop}
      >
        <Text fontSize="1.25rem" color="#2E4469" fontWeight="700" mb="1rem">
          Ordered Service In Last 6hrs
        </Text>
        <TableUI>
          <TableHead className={classes.orderCleansingTableHead}>
            <TableRow>
              <TableCell>Ordered Service</TableCell>
              <TableCell>Order Status</TableCell>
              <TableCell align="center" />
            </TableRow>
          </TableHead>
          <TableBody className={classes.orderCleansingTableBody}>
            {orderList?.map((item) => (
              <TableRow key={item.bsCleansingRequestId}>
                <TableCell>
                  <InfoOrderedService data={item} />
                </TableCell>
                <TableCell>
                  <InfoStatus data={item} />
                </TableCell>
                <TableCell align="center">
                  <Box display="flex" justifyContent="center">
                    {/* 除了Complete都可以删 */}
                    {
                      item?.orderStatus !== 'C' && item?.orderStatus !== 'Y' && (
                        <DeleteServiceOrderBtn data={item} refreshList={getCleansingList} reminder={reminder} />
                      )
                      // <HistoryBtn data={item} />
                    }
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TableUI>
      </Box>
    )
  );
};

export const ServiceTable = ({ orderList = [], withdraw, handleSelectWithdraw }) => {
  const classes = useStyles();
  return (
    <TableUI>
      <TableHead className={classes.orderCleansingTableHead}>
        <TableRow>
          <TableCell>Ordered Service</TableCell>
          <TableCell>Order Status</TableCell>
          {withdraw && <TableCell align="center"> Withdraw </TableCell>}
        </TableRow>
      </TableHead>
      <TableBody className={classes.orderCleansingTableBody}>
        {orderList?.map((item) => (
          <TableRow key={item.bsCleansingRequestId}>
            <TableCell>
              <InfoOrderedService data={item} />
            </TableCell>
            <TableCell>
              <InfoStatus data={item} />
            </TableCell>
            {withdraw && (
              <TableCell align="center">
                <Box display="flex" justifyContent="center">
                  <Checkbox check={item.withdraw} handleChange={handleSelectWithdraw(item.bsCleansingRequestId)} />
                </Box>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </TableUI>
  );
};

const InfoOrderedService = ({ data }) => {
  return (
    <Box display="flex" flexDirection="column" gridGap="0.25rem">
      <Text fontSize="1rem" color="#2E4469">
        {data?.serviceDesc}
      </Text>
      <Text fontSize="0.75rem" color="#616161">
        {data?.serviceRemark}
      </Text>
      <Text fontSize="0.75rem" color="#616161">
        {`Order time: ${moment(data?.orderDate).format('YYYY-MM-DD HH:mm')}`}
      </Text>
    </Box>
  );
};

const InfoStatus = ({ data }) => {
  const classes = useStyles();
  const status = ORDER_SERVICE_STATUS_ENUM?.[data?.orderStatus];
  let time = '';
  if (data?.completedDate) {
    time = `Complete time: ${moment(data?.completedDate).format('YYYY-MM-DD HH:mm')}`;
  } else if (data?.arrivalDate) {
    time = `Arrival time: ${moment(data?.arrivalDate).format('YYYY-MM-DD HH:mm')}`;
  }
  return (
    <Box display="flex" flexDirection="column" gridGap="0.25rem">
      <Box display="flex" gridGap="0.62rem" alignItems="center">
        <Box
          className={classes.circle}
          bgcolor={status?.color}
          border={data?.orderStatus === 'W' ? 'solid 1px #BBBBBB' : 'unset'}
        />
        <Text fontSize="1rem" color="#2e4469">
          {status?.text}
        </Text>
      </Box>
      <Text fontSize="0.75rem" color="#616161">
        {time}
      </Text>
    </Box>
  );
};

const HistoryBtn = ({ data }) => {
  const classes = useStyles();
  const [historyPopup, setHistoryPopup] = useState(false);
  return (
    <>
      <ButtonBase className={classes.orderBtn} onClick={() => setHistoryPopup(true)}>
        <InfoIcon />
      </ButtonBase>
      {historyPopup && <ServiceHistoryPopup handleClose={() => setHistoryPopup(false)} data={data} />}
    </>
  );
};

export const DeleteServiceOrderBtn = ({ data, refreshList, reminder }) => {
  const classes = useStyles();
  const [deletePopup, setDeletePopup] = useState(false);
  return (
    <>
      <ButtonBase className={classes.orderBtn} onClick={() => setDeletePopup(true)}>
        <DeleteIcon />
      </ButtonBase>
      {deletePopup && (
        <CancelServicePopup
          handleClose={() => setDeletePopup(false)}
          handleConfirm={() => {
            setDeletePopup(false);
            refreshList();
          }}
          data={data}
          reminder={reminder}
        />
      )}
    </>
  );
};

const useStyles = makeStyles(() => ({
  orderCleansingTableHead: {
    '& .MuiTableCell-root': {
      backgroundColor: 'unset !important',
      padding: '0 0 0.69rem !important',
    },
    '& .MuiTableRow-root': {
      backgroundColor: 'unset !important',
    },
  },
  orderCleansingTableBody: {
    '& .MuiTableCell-root': {
      padding: '0 0 1.25rem !important',
      border: 'unset !important',
    },
  },
  circle: {
    width: '0.625rem',
    height: '0.625rem',
    borderRadius: '50%',
  },
  orderBtn: {
    border: '1px solid #538FFF',
    padding: '0.38rem',
    borderRadius: '0.5rem',
    color: '#538fff',
    width: '2.25rem',
    height: '2.25rem',
  },
}));
